import { systemHealthService } from "client-app-core";
import * as t from "./actionTypes";

const systemHealthReceived = (data) => {
	return {
		type: t.SYSTEM_HEALTH_RECEIVED,
		payload: data
	};
};

const nodeStatusReceived = (data) => {
	return {
		type: t.NODE_STATUS_RECEIVED,
		payload: data
	};
};

const failoverConfirmed = (data) => {
	return {
		type: t.CLUSTER_FAILOVER_CONFIRMED,
		payload: data
	};
};

const clusterHealthReceived = (data) => {
	return {
		type: t.CLUSTER_HEALTH_RECEIVED,
		payload: data
	};
};

const systemHealthError = () => {
	return {
		type: t.SYSTEM_HEALTH_ERROR,
		payload: true
	};
};

const getSystemHealth = () => {
	return (dispatch) => {
		systemHealthService.getAllWithAuth((err, res) => {
			if (err) {
				console.log("System health error received", err);
				dispatch(systemHealthError());
			} else {
				dispatch(systemHealthReceived(res));
			}
		});
	};
};

export const startHealthPolling = () => {
	return (dispatch) => {
		// Get initial system health on load
		dispatch(getSystemHealth());

		// Poll for system health every 15 seconds
		setInterval(() => {
			dispatch(getSystemHealth());
		}, 15000);
	};
};

const getCheck = (node) => {
	return {
		id: `cluster-node-status-${node.name}`,
		name: node.name,
		desc: "Indicates the status of a node in the cluster",
		value: node.status,
		displayValue:
			node.status === "up"
				? "global.dock.systemHealth.clusterHealth.up"
				: "global.dock.systemHealth.clusterHealth.down",
		status: {
			ok: node.status === "up"
		},
		lastUpdated: new Date().toISOString(),
		essential: true
	};
};

const getNodeStatusHealth = (nodeStatus) => {
	const nodeChecks = [];
	for (const node of nodeStatus.nodes) {
		nodeChecks.push(getCheck(node));
	}

	nodeChecks.sort((a, b) => {
		if (a.name < b.name) {
			return -1;
		}
		if (a.name > b.name) {
			return 1;
		}
		return 0;
	});

	return {
		"cluster-health": {
			label: "global.dock.systemHealth.clusterHealth.label",
			type: "cluster-health",
			systems: [
				{
					label: "global.dock.systemHealth.clusterHealth.systemLabel",
					alwaysShow: true,
					checks: nodeChecks
				}
			],
			error: nodeChecks.some((nodeCheck) => !nodeCheck.status.ok)
		}
	};
};

const getNodeStatus = (timeout) => {
	return (dispatch) => {
		systemHealthService.getNodeStatus(timeout, (err, res) => {
			if (err) {
				console.log("Node status error received", err);
				//dispatch(systemHealthError()); WHAT TO DO WITH FAILURE FROM SERVICE OR 404, timeout etc
			} else {
				res.health = getNodeStatusHealth(res);
				dispatch(nodeStatusReceived(res));
			}
		});
	};
};

export const startNodeStatusPolling = (nodeStatusPingInterval) => {
	return (dispatch) => {
		// Get initial system health on load
		dispatch(getNodeStatus());

		// Poll for system health every 15 seconds
		setInterval(() => {
			dispatch(getNodeStatus(nodeStatusPingInterval));
		}, nodeStatusPingInterval);
	};
};

export const subscribeToClusterHealth = () => {
	return (dispatch) => {
		systemHealthService.streamClusterHealth((err, res) => {
			if (err) console.log(err);
			if (!res) return;
			dispatch(clusterHealthReceived(res));
		});
	};
};

export const confirmFailover = () => {
	return (dispatch) => {
		dispatch(failoverConfirmed({ acked: true }));
	};
};

export const logDataReceived = (bytes) => {
	return (dispatch) => {
		dispatch({
			type: t.LOG_DATA_RECEIVED,
			payload: { bytesReceived: bytes }
		});
	};
};

export const systemHealthConnectedChanged = (connected) => {
	return (dispatch) => {
		dispatch({
			type: t.SYSTEM_HEALTH_CONNECTED,
			payload: connected
		});
	};
};

export const systemHealthOnlineChanged = (online) => {
	return (dispatch) => {
		dispatch({
			type: t.SYSTEM_HEALTH_ONLINE,
			payload: online
		});
	};
};
